// Turbo 8 UJS compatibility
//
// Turbo 7 automatically skipped elements with data-remote="true" (Rails UJS).
// Turbo 8 removed this check, so it intercepts all link clicks and form
// submissions — including ones that UJS should handle.
//
// This restores the Turbo 7 behavior: when Turbo is about to navigate a
// link that carries data-remote="true", we cancel Turbo's navigation and
// let UJS handle it via XHR instead.

document.addEventListener('turbo:click', (event) => {
  if (event.target.closest('[data-remote="true"]')) {
    event.preventDefault()
  }
})
